export default function ERPImpact() {
  return (
    <section className="bg-white px-6 py-12 text-center sm:px-8 sm:py-16">
      <div className="mx-auto w-full max-w-6xl">
        <h2
          className="text-[32px] font-semibold leading-[48px]"
          style={{ color: '#183762' }}
        >
          Open the Floodgates of Success with CRM and ERP Implementation
        </h2>
        <p className="mt-5 text-center text-base font-normal leading-[27px]" style={{ color: '#212121' }}>
          Real-Time Data Insights to Have a Competitive Edge!
        </p>
        <img
          className="mt-10 block h-auto w-full"
          src="https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/EnterpriseSoftwareConsulting/erp.webp"
          alt="CRM and ERP implementation statistics highlighting business growth, customer retention, and cloud ERP adoption"
          loading="lazy"
        />
      </div>
    </section>
  );
}
